import React, {FC, useEffect} from 'react';
import styled, { css } from 'src/theme';
import { Col, Row, Tooltip } from "antd";
import { TooltipProps } from "antd/lib/tooltip";
import {usePresenter} from "./usePresenter";

interface Props {}

export const Step5: FC<Props> = () => {
  const presenter = usePresenter();

  useEffect(() => {}, [presenter.selectedColor])

  const handleClickColor = (id: number) => {
    presenter.setColorID(id);
  }

  return (
    <RowStyled justify='center' style={{ textAlign: 'center' }}>
      <Col xs={23}>
        <HeaderStyled>Выберите цвет кровельного покрытия</HeaderStyled>
        <RowColorStyled gutter={[24, 24]}>

          {presenter.colors.map(color => (
            <Col key={color.id}>
              <TooltipStyled title={<>{color.description1}<br />{color.description2}</>}>
                <ColorStyled
                  color={color.hexCode}
                  onClick={() => handleClickColor(color.id)}
                  $active={color.id === presenter.selectedColor}
                />
              </TooltipStyled>
            </Col>
          ))}


        </RowColorStyled>
      </Col>
    </RowStyled>
  );
};

const ColorStyled = styled.button<{ $active?: boolean, color: string }>`
  ${(props) => css`
    width: 44px;
    height: 44px;
    border-radius: 22px;
    background: ${props.color};
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    
    border: ${props.$active ? `1.5px solid ${props.theme.colors.orange}` : 'none'};
    @media screen and ${props.theme.media.tablet} {}
  `}
`;

const RowColorStyled = styled(Row)`
  padding: 24px;
  max-width: 524px;
  margin: 0 auto !important;
  background: ${props => props.theme.colors.white};
`;

const RowStyled = styled(Row)`
  padding: 25px 10px;
  background: ${props => props.theme.colors.smoke};
  border-radius: 6px;
`;

const HeaderStyled = styled.h4`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  margin-bottom: 15px;
  color: ${props => props.theme.colors.nero};
`;

const TooltipStyled = styled((props: TooltipProps) => <Tooltip {...props} />)`

  & .ant-tooltip-content {
    background: ${props => props.theme.colors.white};

    border: 1px solid ${props => props.theme.colors.orange};
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }

  & .ant-tooltip-arrow {
    display: none;
  }

  & .ant-tooltip-inner {
    font-family: PT Root UI, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: ${props => props.theme.colors.black};
  }
`;
